<template>
    <CardContentPanel icon="creditcard" v-bind="{action, index}">
        <template #title>{{ $t('projectclient.projectview.activity.pending.actions.PREPAY_PROJECT.title') }}</template>
        <template #body>
            <p>{{ getLabel }}</p>
            <VJoyHighlight v-if="isPaymentInProgress" :accent="true" level="info">
                <template #default>
                    {{ $t('projectclient.projectview.activity.pending.actions.PREPAY_PROJECT.awaitingPayment') }}
                </template>
            </VJoyHighlight>
        </template>
        <template #actions>
            <NuxtLink
                :to="`/project-payment/${projectInformationStore.projectInformation.projectId}?origin=project-view`"
                external
                data-testid="pending-action-card-cta-primary"
            >
                <VJoyButton size="small" :variant="ctaVariant">
                    {{ $t('projectclient.projectview.activity.pending.actions.PREPAY_PROJECT.action.primary') }}
                </VJoyButton>
            </NuxtLink>
        </template>
    </CardContentPanel>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useTranslation, useFormat} from '#imports';
    import type {TJoyButtonVariants} from '@maltjoy/core-vue';
    import {VJoyButton, VJoyHighlight} from '@maltjoy/core-vue';
    import CardContentPanel from '../../CardContentPanel.vue';
    import {useProjectInformationStore} from '@/common/stores';
    import type {ActivityPendingActionByType} from '@/features/project-view';

    const props = defineProps<{
        action: ActivityPendingActionByType<'PREPAY_PROJECT'>;
        index: number;
    }>();

    const projectInformationStore = useProjectInformationStore();
    const {formatDate, formatAmount} = useFormat();
    const {t} = useTranslation();

    const isPaymentInProgress = computed<boolean>(() => props.action.extraData.paymentInProgress === 'true');

    const ctaVariant = computed<TJoyButtonVariants>(() => (isPaymentInProgress.value ? 'secondary' : 'main'));

    const formattedAmount = computed<string>(() => {
        const amount = props.action.extraData.remaining;
        return !isNaN(amount) ? formatAmount(projectInformationStore.projectInformation.contract.currency, amount, {decimals: 2}) : '-';
    });

    const getLabel = computed(() => {
        const translationKey = `projectclient.projectview.activity.pending.actions.PREPAY_PROJECT.description`;
        return t(translationKey, [formattedAmount.value]);
    });
</script>
